const CREDIT_LINE_STATUS = {
  APPROVED: 'approved',
  PENDING: 'pending',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
  PAUSED: 'paused',
  ERROR: 'error',
};

const LOAN_STATUS = {
  ON_TIME: 'on_time',
  OVERDUE: 'overdue',
  FINISHED: 'finished',
  EMPTY_STATE: 'empty_state',
};

const CREDIT_LINE_STATUS_DETAIL = {
  MANUALLY_PAUSED: 'manually_paused',
  AUTO_ENROLLMENT: 'auto_enrollment',
  CONSUMERS_RESTRICTION_AUTO: 'consumers_restriction_auto',
  CONSUMER_ACUMULATED_PF_AUTO: 'consumer_acumulated_pf_auto',
  CONSUMER_CREDIT_CARD_AUTO: 'consumer_credit_card_auto',
};

const INSTALLMENT_STATUS = {
  ON_TIME: 'on_time',
  PAID: 'paid',
  TO_EXPIRE_SOFT: 'to_expire_soft',
  TO_EXPIRE_HARD: 'to_expire_hard',
  EXPIRED_TODAY: 'expired_today',
  NO_CHARGE_PERIOD: 'no_charge_period',
  FIXED_CHARGE_PERIOD_1: 'fixed_charge_period_1',
  FIXED_CHARGE_PERIOD_2: 'fixed_charge_period_2',
  DAILY_CHARGE_PERIOD: 'daily_charge_period',
};

const AMORTIZATION_SYSTEMS = {
  DIRECT_RATE: 'direct_rate',
  ML_SYSTEM: 'ml_system',
  FRENCH_WITH_IVA: 'french_with_iva',
  MLB_FRENCH: 'mlb_french',
  MONTHLY_FRENCH: 'monthly_french',
};

const USER_MONEY_CONDITIONS = {
  ENOUGH_MONEY: 'enough_money',
  NOT_ENOUGH_MONEY: 'not_enough_money',
  WITHOUT_MONEY: 'without_money',
};

const DAYS_APART_BY_INSTALLMENT_STATUS = {
  ABOUT_TO_EXPIRE: 10,
  TO_EXPIRE_SOFT: 3,
  TO_EXPIRE_HARD: 1,
  NO_CHARGE_PERIOD: 2,
  FIXED_CHARGE_PERIOD_1: 4,
  FIXED_CHARGE_PERIOD_2: 14,
  DAILY_CHARGE_PERIOD: 24,
};

const PRODUCT_TYPE = {
  CONSUMER: 'consumer_loan',
  PERSONAL: 'personal_loan',
  SPL: 'sale_percentage_loan',
  FIXED_TERM: 'fixed_term_loan',
  EXPRESS_MONEY: 'express_money',
  SHORT_LOAN: 'short_loan',
};

const COLLECTION_STATUS = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING: 'pending',
};

const REFERENCE_TYPE = {
  INSTALLMENT: 'installment',
};

module.exports = {
  CREDIT_LINE_STATUS,
  LOAN_STATUS,
  CREDIT_LINE_STATUS_DETAIL,
  INSTALLMENT_STATUS,
  AMORTIZATION_SYSTEMS,
  PRODUCT_TYPE,
  COLLECTION_STATUS,
  REFERENCE_TYPE,
  USER_MONEY_CONDITIONS,
  DAYS_APART_BY_INSTALLMENT_STATUS,
};
